import { FormStep } from './form-step';

export class SummaryStep extends FormStep {
  constructor(text: string, name: string) {
    super(text, name, []);
  }
}
